import styled, { css } from 'styled-components';

interface Props {
  size?: number;
  backgroundColor?: string;
  type?: number;
  borderRadius?: string;
  iconSize?: number;
  isClickable?: boolean;
}

const IconDiv = styled.div<Props>`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: ${({ type }) => type === 4 && 'hidden'};
  border-radius: ${({ borderRadius }) => borderRadius || '6px'};
  flex-shrink: 0;
  background-color: ${({ backgroundColor, type }) => {
    if (type === 3 || type === 4) return 'var(--background-primary)';
    return backgroundColor || '#d83426';
  }};
  border: ${({ type }) => (type === 1 || type === 2 ? '0.5px solid transparent' : '0.5px solid var(--border-primary)')};

  ${({ isClickable }) =>
    isClickable &&
    css`
      &:hover,
      &:active {
        opacity: 0.9;
      }
    `}

  p {
    margin: 0;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
    `}
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
  svg {
    fill: var(--text-white);
  }
`;

const Text = styled.div<Props>`
  color: var(--text-white);
  font-size: ${({ size }) => (size === 20 ? '11px' : size === 36 ? '16px' : '13px')};
  font-weight: 600;
  line-height: ${({ size }) => (size === 20 ? '20px' : size === 36 ? '36px' : '23px')};
`;

const EmojiDiv = styled.p<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  font-size: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
`;

const SVGIconDiv = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '16px')};
`;

export { IconDiv, Text, EmojiDiv, SVGIconDiv };
